import React, { useState, useEffect } from 'react'
import './reviewstage.css'
import ArrowSubmit from '../../../components/Icons/arrowsubmit';
import { renderStageRequiredField } from "./RenderRequiredField"
import Grid from '@mui/material/Grid';
import candidateBulkAction from '../../../apis/candidateBulkAction/candidateBulkAction';
import { NotificationManager } from 'react-notifications'
import configJson from '../../../Config.json';
import deleteCandidateActivity from "../../../apis/deleteCandidateActivityEventById/deleteCandidateActivityEventById"
import CircularProgress from "@mui/material/CircularProgress";
import { DateTime } from 'luxon';

const ReviewStages = ({ candidate,
    setEditCandidateStageToggle,
    candidateRequisitionStatus,
    submitDataFromModal,
    userId,
    recruitmentpartnerId,
    setSubmitDataFromModal,
    setSelectedCandidate,
    handleCloseModal,
    candidateList,
    setCandidateList,
    userType,
    moveCandidate,
    sourcePage,
    checkSpocRequired,
    requisitionDetailData
}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const eventStatusArr = candidate?.submitData?.eventStatus || [];
    const tabs = eventStatusArr.map(status => {
        const statusMeta = candidateRequisitionStatus?.find(
            s => s.candidateStatusCode === status.candidateStatusCode
        );
        return {
            id: status.candidateStatusCode,
            label: statusMeta?.name || status.candidateStatusCode,
            eventStatusObj: status
        };
    });
    const defaultTab = tabs[tabs.length - 1]?.id;
    const [activeTab, setActiveTab] = useState(defaultTab);

    useEffect(() => {
        setActiveTab(defaultTab);
    }, [defaultTab]);

    const activeTabObj = tabs.find(tab => tab.id === activeTab);
    const eventStatusData = activeTabObj?.eventStatusObj;

    // Only show buttons on the last tab
    const isLastTab = activeTab === tabs[tabs.length - 1]?.id;

    // Local state for field values in the current tab
    const [fieldValues, setFieldValues] = useState({});

    // Initialize field values when tab or candidate changes
    useEffect(() => {
        if (eventStatusData) {
            const logs = Array.isArray(eventStatusData.activityLogs)
                ? eventStatusData.activityLogs[0] || {}
                : eventStatusData.activityLogs || {};
            setFieldValues(logs);
        }
    }, [eventStatusData, candidate]);

    const updateSubmitDataState = (field, value) => {
        setFieldValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    function convertDate(str) {
        if (str === "") return ""; 
        const date = new Date(str);
        return DateTime.fromJSDate(date).toISODate();
    }

    const handleUpdateStage = async () => {
        setIsSaving(true);
        try {
            let index = submitDataFromModal.findIndex(item => item.email === candidate?.candidateData?.emailID);
            let eventStatusData = submitDataFromModal[index]?.eventStatus?.find(
                item => item.candidateStatusCode === activeTab
            );

            let initialRtrMailShoot = false;

            let currentActivityStatus = eventStatusData?.activityLogs[0] || {};

            let isCurrentStatus = submitDataFromModal[index]?.currentStatus?.candidateStatusCode === activeTab;

            if (
                activeTab === configJson.candidateRequisitionStatusCode.SUBMITTED &&
                currentActivityStatus.submissionStatus === "Internal" &&
                fieldValues["submissionStatus"] === "External"
            ) {
                initialRtrMailShoot = true;
            }

            for (let key in fieldValues) {
                let keyValue = fieldValues[key];
                if (key === 'eventDate' || key === 'endDate' || key === "startedDate") {
                    keyValue = convertDate(keyValue);
                }
                currentActivityStatus[key] = keyValue;
                if (isCurrentStatus) {
                    submitDataFromModal[index][key] = keyValue;
                    if (key === 'submissionStatus') {
                        submitDataFromModal[index].submissionType = keyValue;
                    }
                }
            }

            let item = submitDataFromModal[index];

            let requiredData = {
                candidateReqExist: true,
                candidateRequisitionId: item.candidateRequisitionId || '',
                currentActivityStatus: currentActivityStatus || {},
                candidateResumeDetailsId: item.candidateDetailId || '',
                email: item.email || '',
                name: item.name || '',
                endDate: item.endDate || '',
                eventDate: item.eventDate || '',
                hourlyMargin: item.hourlyMargin || '',
                hourlyPayRate: item.hourlyPayRate || '',
                notes: item.notes || '',
                phone: item.phone || '',
                status: {
                    candidateStatusCode: eventStatusData.candidateStatusCode || '',
                    candidateStatusCodeId: eventStatusData?.candidateStatusCodeId || '',
                },
                currentStatus: {
                    candidateStatusCode: item?.currentStatus?.candidateStatusCode || '',
                    candidateStatusCodeId: item?.currentStatus?._id || '',
                },
                resumeLink: item.resumeLink || [],
                salary: item.salary || '',
                isActive: true,
                submissionType: item.submissionType || '',
                displayDate: item.displayDate || '',
                isStageChanged: false,
                isStageValueUpdated: true,
                requisitionDetailId: item?.requisitionDetailId,
                requisitionId: item.requisitionId || '',
                requisitionLeaderId: item.requisitionLeaderId || '',
                requisitionRecruiterId: item.requisitionRecruiterId || '',
                requisitionTeamLeaderId: item.requisitionTeamLeaderId || '',
                teamId: item?.teamId,
                teamLeaderId: item?.teamLeaderId,
                recruiterId: item?.recruiterId,
                recruitmentLeaderId: item?.recruitmentLeaderId || '',
            };

            if (initialRtrMailShoot) {
                requiredData.initialRtrMailShoot = initialRtrMailShoot;
                requiredData.isSubmissionMailSend = true;
                requiredData.candidateSubmissionData = item.candidateSubmissionData || null;
                requiredData.isSpocRequired = checkSpocRequired();
            }

            let payload = {
                recruitmentpartnerId: recruitmentpartnerId || '',
                senderId: userId || '',
                candidateActionArr: [requiredData],
            };


            let response = await candidateBulkAction(payload);
            if (response.status === 200) {

                let updatedSubmitData = [...submitDataFromModal];
                eventStatusData = updatedSubmitData[index]?.eventStatus
                let eventStatusIndex = eventStatusData.findIndex(item => item.candidateStatusCode === activeTab);
                eventStatusData[eventStatusIndex].activityLogs = [currentActivityStatus];
                updatedSubmitData[index].eventStatus = eventStatusData;
                if (isLastTab) {
                    for (let key in fieldValues) {
                        updatedSubmitData[index][key] = fieldValues[key];
                    }
                }
                setSubmitDataFromModal(updatedSubmitData);
                setSelectedCandidate({
                    ...candidate,
                    submitData: updatedSubmitData[index]
                });
                NotificationManager.success(response.data.message, "Success", 10000);
            }

        } catch (error) {
            console.error("Error during bulk submit:", error);
            NotificationManager.error("Failed to submit candidates", "Error", 10000);
        } finally {
            setIsSaving(false);
        }
    };

    const handleCandidateDataAfterDelete = (index, payload) => {
        let submitModalData = [...submitDataFromModal];
        let eventStatusdata = submitModalData[index]?.eventStatus || [];
        eventStatusdata = eventStatusdata.filter((item) => item.candidateStatusCode !== activeTab);
        submitModalData[index].eventStatus = eventStatusdata;
        let currentStatusValue = candidateRequisitionStatus?.find(
            item => item.candidateStatusCode === eventStatusdata?.at(-1)?.candidateStatusCode
        );
        submitModalData[index].status = currentStatusValue || {};
        submitModalData[index].currentStatus = currentStatusValue || {};
        submitModalData[index].currentActivityStatus = {
            candidateStatusCode: eventStatusdata?.at(-1)?.candidateStatusCode || '',
            candidateStatusCodeId: eventStatusdata?.at(-1)?.candidateStatusCodeId || '',
            activityLogs: eventStatusdata?.at(-1)?.activityLogs[0] || {},
        };
        submitModalData[index].newActivityStatus = {}


        if (eventStatusdata.length > 0) {
            if (payload?.update?.activityLogs?.length > 0) {
                let fields = payload?.update?.activityLogs[0];
                for (let key in fields) {
                    if (key !== '_id') {
                        submitModalData[index][key] = fields[key];
                    }
                }
            }
            setActiveTab(submitModalData[index]?.eventStatus?.at(-1)?.candidateStatusCode || defaultTab);
            setSelectedCandidate({
                ...candidate,
                submitData: submitModalData[index],
                submittedByOther: submitModalData[index]?.submittedByOther || false
            })
        }
        else {
            submitModalData.splice(index, 1);
            if (submitModalData.length === 0) {
                setEditCandidateStageToggle(false);
                handleCloseModal();
            }
            else {
                let currentCandidateList = candidateList.filter(item => item.emailID !== candidate?.candidateData?.emailID);
                setCandidateList(currentCandidateList);
                let emailId = submitModalData[0]?.email || '';
                let tobeSelectedCandidate = currentCandidateList.find(item => item.emailID === emailId);
                setSelectedCandidate({
                    candidateData: tobeSelectedCandidate || null,
                    submitData: submitModalData[0] || {},
                    submittedByOther: submitModalData[0]?.submittedByOther || false
                });
                setEditCandidateStageToggle(false);
            }
        }
        setSubmitDataFromModal(submitModalData);
        setIsDeleting(false);
    }

    const handleDeleteStage = async () => {
        setIsDeleting(true);
        let index = submitDataFromModal.findIndex(item => item.email === candidate?.candidateData?.emailID);
        let payload = {
            requisitionId: submitDataFromModal[index]?.requisitionId || '',
            email: submitDataFromModal[index]?.email || '',
            Id: submitDataFromModal[index]?.candidateRequisitionId || '',
            senderId: userId || '',
            dataDelete: submitDataFromModal[index]?.eventStatus?.at(-1),
            update: submitDataFromModal[index]?.eventStatus?.at(-2),
        }
        try {
            let response = await deleteCandidateActivity(payload);
            if (response.status === 200) {
                handleCandidateDataAfterDelete(index, payload);
                if (sourcePage === 'Activity') {
                    let candidatePayload = {
                        email: submitDataFromModal[index]?.email || '',
                        isDeleted: payload.dataDelete?.candidateStatusCode === configJson.candidateRequisitionStatusCode.SUBMITTED ? true : false,
                        isStageChanged: true,
                        status: {
                            candidateStatusCode: payload.update?.candidateStatusCode || '',
                            candidateStatusCodeId: payload.update?.candidateStatusCodeId || '',
                        },
                        currentStatus: {
                            candidateStatusCode: payload.dataDelete?.candidateStatusCode || '',
                            candidateStatusCodeId: payload.dataDelete?.candidateStatusCodeId || '',
                        },
                        ...payload.update?.activityLogs?.[0] || {},
                    }
                    if (payload.dataDelete?.candidateStatusCode === configJson.candidateRequisitionStatusCode.SUBMITTED) {
                        candidatePayload.status = candidatePayload.currentStatus;
                    }
                    await moveCandidate([candidatePayload]);
                }
                NotificationManager.success("Stage deleted successfully", "Success", 10000);
            }
        } catch (error) {
            console.error("Error during deleting stage:", error);
            NotificationManager.error(error.response?.data?.message, "Error", 10000);
        } finally {
            setIsDeleting(false);
        }

    }



    return (
        <div className="reviewStages_container">
            <div className="candidateDetailsCard_bulkSubmit">
                <div className="candidateDetailsHeader_bulkSubmit">
                    <span className="candidateDetailsTitle_bulkSubmit">Candidate Details</span>
                </div>
                <div className="candidateDetailsContent_bulkSubmit">
                    <div className="candidateAvatar_bulkSubmit">{
                        candidate?.candidateData?.name
                            ? candidate.candidateData.name.split(' ').map((n) => n[0]).join('').toUpperCase()
                            : ''
                    }</div>
                    <div className="candidateInfo_bulkSubmit">
                        <div className="candidateInfoRow_bulkSubmit">
                            <span className="candidateInfoLabel_bulkSubmit">Name:</span>
                            <span className="candidateInfoValue_bulkSubmit">{candidate?.candidateData?.name || '-'}</span>
                        </div>
                        <div className="candidateInfoRow_bulkSubmit">
                            <span className="candidateInfoLabel_bulkSubmit">Email:</span>
                            <span className="candidateInfoValue_bulkSubmit">{candidate?.candidateData?.emailID || candidate?.candidateData?.email || '-'}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="stagesContainer">
                <h3 className="stagesTitle">Stages</h3>
                <div className="tabsContainer_reviewStages">
                    <div className="tabsScrollable">
                        {tabs.map(tab => (
                            <div
                                key={tab.id}
                                className={`tab_reviewStages ${activeTab === tab.id ? 'active_current' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                <span className="tabLabel">{tab.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='detailInfoContainer_bulkSubmit'>
                <div
                    className='detailInfoContainerTitle_bulkSubmit'
                >
                    <ArrowSubmit className={`arrowIcon_bulkSubmit expanded`} />
                    <span>Require fields for this stage</span>
                </div>
                <div className="sectionContent_bulkSubmit">
                    <div className="formContainer_bulkSubmit">
                        <Grid container spacing={3}>
                            {renderStageRequiredField(
                                candidate?.submitData,
                                candidateRequisitionStatus,
                                requisitionDetailData,
                                updateSubmitDataState,
                                { ...eventStatusData, activityLogs: fieldValues }
                            )}
                        </Grid>


                        <div className="change_button_container">
                            <button
                                className="saveStageButton"
                                onClick={handleUpdateStage}
                                disabled={isSaving}
                            >
                                {isSaving ? (
                                    <span className="loadingWrapper">
                                        <CircularProgress size={16} thickness={4} color="inherit" />
                                        <span>Saving...</span>
                                    </span>
                                ) : (
                                    "Save Changes"
                                )}
                            </button>

                            {(isLastTab && userType === 'MIS Operator') && (
                                <button
                                    className="deleteStageButton"
                                    onClick={handleDeleteStage}
                                    disabled={isDeleting}
                                >
                                    {isDeleting ? (
                                        <span className="loadingWrapper">
                                            <CircularProgress size={16} thickness={4} color="inherit" />
                                            <span>Deleting...</span>
                                        </span>
                                    ) : (
                                        "Delete Stage"
                                    )}
                                </button>
                            )}
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReviewStages

